import { useNavigate } from "react-router-dom";
import { AccountLinkFlow } from "./AccountLinkFlow";

function AccountLinkPage() {
  const navigate = useNavigate();
  return <AccountLinkFlow closeFunction={() => navigate("/")} />;
}

export { AccountLinkPage };
